import React, { useContext, useState, useEffect } from "react";
import { Banner, Button, Link, Select, Stack } from "@shopify/polaris";

import { PrivateContext } from "lib/context";
import { withErrorBoundary } from "lib/hoc";
import { useQuery } from "react-apollo";

import { GET_SENDABOX_CARRIER, GET_VENDOR_AND_PRODUCT_TYPES } from "app/setup/apollo";
import { FulfillmentContext } from "app/setup/modules/operator/features/_fulfillment/context";
import { baseHelper, errorHelper } from "lib/helpers";
import { Spinner } from "lib/components";

import constant from "lib/constant/constant";

const CarrierService = (props) => {
  const { error: errorValue } = props;
  const { cms } = useContext(PrivateContext);
  const { dropship, setDropship, setSubmitEnable, setIsError } = useContext(FulfillmentContext);
  let error = false;
  Object.values(errorValue).forEach((value) => {
    if (value) {
      error = true;
    }
  });
  const [sendaboxList, setSendaboxList] = useState();
  const [vendorList, setVedorList] = useState();

  const [carrierService, setCarrierService] = useState(
    (dropship && dropship.sendabox && dropship.sendabox.vendorCarrier) || []
  );

  const [defaultCarrier, setDefaultCarrier] = useState(
    (dropship && dropship.sendabox && dropship.sendabox.defaultCarrier) || {}
  );
  const [banner, setBanner] = useState({
    isOpen: false,
    status: "",
    title: "",
    onDismiss: null,
  });

  const { error: sendaboxError, loading: sendaboxLoading, data: sendaboxData } = useQuery(GET_SENDABOX_CARRIER);

  useEffect(() => {
    if (sendaboxError) {
      setBanner({ isOpen: true, status: constant.CRITICAL, title: errorHelper.parse(sendaboxError) });
    }
    if (!sendaboxData) {
      return;
    }
    const sendaboxCarrierData = baseHelper.getResponseData(sendaboxData, constant.gql.GET_SENDABOX_CARRIER);
    if (!sendaboxCarrierData) {
      return;
    }

    if (sendaboxCarrierData) {
      const sendaboxDataList = sendaboxCarrierData.map((item) => {
        return {
          label: item.label,
          name: item.name,
          value: item.id,
          service: item.service,
        };
      });
      setSendaboxList(sendaboxDataList);
    }

    const sendaboxCarrierError = baseHelper.getResponseError(sendaboxData, constant.gql.GET_SENDABOX_CARRIER);
    if (sendaboxCarrierError) {
      setBanner({ isOpen: true, status: constant.CRITICAL, title: sendaboxCarrierError });
    }
  }, [sendaboxData, sendaboxError]);

  const {
    loading: vendorAndProductTypesLoading,
    error: vendorAndProductTypesError,
    data: vendorAndProductTypesData,
  } = useQuery(GET_VENDOR_AND_PRODUCT_TYPES);

  useEffect(() => {
    if (vendorAndProductTypesError) {
      setBanner({ isOpen: true, status: constant.CRITICAL, title: errorHelper.parse(vendorAndProductTypesError) });
      return;
    }
    const responseData = baseHelper.getResponseData(vendorAndProductTypesData, constant.gql.GET_VENDOR_PRODUCT);
    const { supplierRows = [] } = responseData;

    if (!responseData) {
      return;
    }

    const selectedSuppliers = [];
    if (dropship && dropship.sendabox && dropship.sendabox.vendorCarrier && dropship.sendabox.vendorCarrier.length) {
      dropship.sendabox.vendorCarrier.map((data) => selectedSuppliers.push(data.vendorId));
    }
    const suppliers = supplierRows.filter((item) => {
      const { _id: id } = item;
      const itemData = item;
      if (itemData.brandName) {
        if (!selectedSuppliers.includes(id)) {
          itemData.disabled = false;
        }
        if (selectedSuppliers.includes(id)) {
          itemData.disabled = true;
        }
        return itemData;
      }
      return null;
    });

    const formattedSuppliers = suppliers
      .filter((item) => item.brandName && item)
      .map(({ _id: vendorId, brandName, disabled }) => ({
        label: brandName,
        value: vendorId,
        disabled,
      }));

    setVedorList(formattedSuppliers);
  }, [dropship, setVedorList, vendorAndProductTypesData, vendorAndProductTypesError, vendorAndProductTypesLoading]);

  const addItem = () => {
    const sendaboxItem = [...carrierService];
    if (sendaboxItem.length > 0) {
      const item = sendaboxItem[sendaboxItem.length - 1];
      const keys = Object.keys(item);
      let isInvalid = false;
      keys.forEach(() => {
        if (!item.vendorId || !item.id) {
          isInvalid = true;
        }
      });

      if (isInvalid) {
        setIsError(isInvalid);
        setBanner({
          isOpen: true,
          title: cms("common.message.error.invalidRowDetails"),
          status: constant.CRITICAL,
        });
      } else
        sendaboxItem.push({
          id: "",
          name: "",
          vendorId: "",
          service: "",
        });
      setCarrierService(sendaboxItem);
    }
    const isInvalidRow =
      sendaboxItem.length && !!sendaboxItem.find((element) => !element.id || !element.vendorId || !element.service);
    setIsError(isInvalidRow);
    if (!sendaboxItem.length) {
      setCarrierService([{ id: "", name: "", vendorId: "", service: "" }]);
    }
  };

  const handleChange = (field, value, index) => {
    const oldSendabox = (dropship && dropship.sendabox) || {};
    const sendaboxItem = [...carrierService];
    sendaboxItem[index][field] = value;
    const updateVendorCarrier = [];
    carrierService.map((element) => {
      const sendaboxListItem = sendaboxList.find((item) => item.value === element.id);
      if (element.id && element.vendorId && sendaboxListItem) {
        updateVendorCarrier.push({
          id: sendaboxListItem.value,
          name: sendaboxListItem.name,
          service: sendaboxListItem.service,
          vendorId: element.vendorId,
        });
        sendaboxItem[index].name = sendaboxListItem.name;
        sendaboxItem[index].service = sendaboxListItem.service;
      }
      return null;
    });

    const isInvalidRow = !!carrierService.find((item) => !(item.id && item.vendorId));

    setIsError(isInvalidRow);

    setCarrierService([...sendaboxItem]);
    setDropship((prevState) => ({
      ...prevState,
      sendabox: { ...oldSendabox, vendorCarrier: updateVendorCarrier || carrierService },
    }));
    if (!error) {
      setSubmitEnable(true);
    }
  };

  const removeItem = (id) => {
    const sendaboxItem = [...carrierService];
    const oldSendabox = (dropship && dropship.sendabox) || {};
    sendaboxItem.splice(id, 1);
    setCarrierService(sendaboxItem);
    setDropship((prevState) => ({
      ...prevState,
      sendabox: { ...oldSendabox, vendorCarrier: [...sendaboxItem] },
    }));
    const isInvalidRow =
      sendaboxData.length && !!sendaboxItem.find((element) => !element.id || !element.vendorId || !element.service);
    setIsError(isInvalidRow);
    if (!error) {
      setSubmitEnable(true);
    }
  };

  const handleDefaultChange = (value) => {
    const oldSendabox = (dropship && dropship.sendabox) || {};
    const updateDefaultCarrierData =
      sendaboxList && sendaboxList.find(({ value: carrierServiceValue }) => carrierServiceValue === value);
    let updateValue = {};
    if (updateDefaultCarrierData) {
      updateValue = {
        name: updateDefaultCarrierData.name,
        id: updateDefaultCarrierData.value,
        service: updateDefaultCarrierData.service,
      };
    }
    setDefaultCarrier((prevState) => ({
      ...prevState,
      id: value,
    }));
    setDropship((prevState) => ({
      ...prevState,
      sendabox: { ...oldSendabox, defaultCarrier: updateValue || defaultCarrier },
    }));
    if (!error) {
      setSubmitEnable(true);
    }
  };

  // set default sendabox carrier SDA defined in constant
  useEffect(() => {
    const selectedCarrier =
      sendaboxList &&
      sendaboxList.find(({ service: carrierName }) => carrierName === constant.SENDABOX_DEFAULT_CARRIER);
    if (selectedCarrier && dropship.sendabox && !dropship.sendabox.defaultCarrier) {
      handleDefaultChange(selectedCarrier.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendaboxList]);

  const selectVendor = (data, id) => {
    return (
      <>
        <br />
        <Stack wrap={false} spacing="extraTight" alignment="center" key={id}>
          <Stack.Item>
            <div className="formWidth125px">
              <Select
                options={vendorList}
                placeholder={cms("placeholder.vendors")}
                value={carrierService && carrierService.length && carrierService[id].vendorId}
                onChange={(value) => {
                  handleChange(constant.VENDOR_ID, value, id);
                }}
              />
            </div>
          </Stack.Item>
          <Stack.Item>
            <div className="formWidth125px">
              <Select
                options={sendaboxList}
                placeholder={cms("placeholder.carrier")}
                value={carrierService && carrierService.length && carrierService[id].id}
                onChange={(value) => handleChange(constant.ACCESS_KEY_ID, value, id)}
              />
            </div>
          </Stack.Item>
          <Button size="plain" onClick={() => removeItem(id)}>
            <i className="far fa-trash fa-lg" style={{ color: constant.color.RED }} />
          </Button>
        </Stack>
      </>
    );
  };

  if (sendaboxLoading) {
    return <Spinner size="small" />;
  }
  return (
    <div>
      {banner.isOpen && (
        <>
          <br />
          <Banner
            isOpen={banner.isOpen}
            status={banner.status}
            title={banner.title}
            onDismiss={() => setBanner({ isOpen: false, title: "", status: "" })}
          />
        </>
      )}
      <br />
      <Select
        label={cms("label.carrier")}
        options={sendaboxList}
        placeholder={cms("placeholder.carrier")}
        value={(defaultCarrier && defaultCarrier.id) || ""}
        onChange={(value) => handleDefaultChange(value)}
      />
      {carrierService &&
        carrierService.map((value, index) => {
          return selectVendor(value, index);
        })}
      <br />
      <Link id="addLink" onClick={() => addItem()}>
        {cms("button.vendor")}
      </Link>
    </div>
  );
};

export default withErrorBoundary(CarrierService);
